export class CardType {
  front: string
  back: string
  id : string
  repetitions: number = 0;
  interval: number = 1;
  easiness: number = 2.5;
  created: number = new Date().getTime()
  nextPracticeDate: number = new Date().getTime()
  constructor ({ front = '', back = '', id = '', repetitions = 0, interval = 1, easiness = 2.5, created = new Date().getTime(), nextPracticeDate = new Date().getTime() }:{front?: string, back?: string, id?: string, repetitions?: number, interval?: number, easiness?: number, created?:number, nextPracticeDate?:number}) {
    this.front = front
    this.back = back
    this.id = id
    this.repetitions = repetitions
    this.interval = interval
    this.easiness = easiness
    this.created = created
    this.nextPracticeDate = nextPracticeDate
  }
  hasValues () {
    if (this.front !== '' && this.back !== '') {
      return true
    }
    return false
  }
  hasSomeValue () {
    if (this.front !== '' || this.back !== '') {
      return true
    }
    return false
  }

  toString () {
    return Object.assign({}, this)
  }
}

export type States = 0 | 200 | 500 | 201 | 501 | 202 | 502
export type Modes = 'question' | 'answer' | 'edit'

export type DeckType = CardType[]

declare global {
  interface Window { analytics: any; }
}

export interface DeckInfo {
  name:string
  owner:string
  count?:number
}
